module.exports = __webpack_public_path__ + "static/img/pay_success.5aacc8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/assets/join/pay_success.png
// module id = cX5B
// module chunks = 9